/**
 * Mobile Logo Component
 * Shared across all portals
 */

export function MobileLogo() {
  return (
    <div className="flex items-center gap-2 mx-auto">
      <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-primary to-primary/80 flex items-center justify-center shadow-sm shadow-primary/25">
        <span className="text-primary-foreground font-bold text-sm">S</span>
      </div>
      <span className="font-bold text-foreground">SPCC</span>
    </div>
  )
}
